/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import axios                from 'axios';
import 'react-table/react-table.css';
import { apiUrl } from '../lib/constants';
import { removeFromArray }  from '../helpers';

class Problemes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            problemes     : [],
            problemeStyle : {},
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        axios.get(apiUrl + '/api/v1/probleme').then((response) => {
            this.setState({
                problemes : response.data,
            });
        });
    }

    componentDidMount() {
        this.setState({ problemeStyle: { width: '25%' } });
    }

    handleChange(e) {
        e.target.checked = true;
        const menuProblemes = this.props.model.slice();
        if (e.target.checked) { menuProblemes.push(e.target.value); } else { removeFromArray(menuProblemes, e.target.value); }
        this.props.updateProblemes(menuProblemes);
    }

    render() {
        return (
            <div
                className="problemes-form"
                style={{
                    width           : '100%', margin          : '10px 0', border          : '1px #000 solid', padding         : '10px', backgroundColor : '#FFF',
                }}
            >
                <div className="form-row">
                    {
                        this.state.problemes.map((probleme, index) => (
                            <div className="probleme" key={index} style={this.state.problemeStyle}>
                                <label htmlFor={probleme.nom}>
                                    {probleme.nom}
                                    <input
                                        type="checkbox"
                                        name={probleme.nom}
                                        onChange={e => this.handleChange(e)}
                                        value={probleme.id_probleme}
                                        checked={this.props.model.indexOf(probleme.id_probleme) !== -1}
                                    />
                                </label>
                            </div>))
                    }
                </div>
            </div>
        );
    }
}

// Declaration des props du composant
Problemes.propTypes = { model: PropTypes.array, updateProblemes: PropTypes.func };
// Définition par defaut (si non-attribué a l'appel du composant) des props
Problemes.defaultProps = { model: [], updateProblemes: () => undefined };

export default Problemes;



// WEBPACK FOOTER //
// ./src/components/Problemes.js